import React from 'react';
import './UpgradeBanner.css';

/**
 * UpgradeBanner — persistent, non-blocking reminder shown to unpaid clients.
 * Unlike the old TrialPaywall, this does NOT replace the app shell — users can
 * browse the full dashboard freely. Specific paid actions (sending messages,
 * campaigns, AI features) are gated individually with their own lock/upgrade
 * prompts; this banner is just the ambient "you're in browse mode" signal.
 */
export default function UpgradeBanner({ onUpgrade }) {
  return (
    <div className="upgrade-banner">
      <span className="upgrade-banner__icon">🔒</span>
      <span className="upgrade-banner__text">
        You're browsing in free mode. Upgrade to activate messaging, AI responses, and campaigns.
      </span>
      <button className="upgrade-banner__btn" onClick={onUpgrade}>
        Upgrade →
      </button>
    </div>
  );
}
